import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './styles.scss';

const WidgetHeader = ({icon, heading}) => {

    const classes = classNames('widget-header__text', {[`widget-header__icon widget-header__icon-${icon}`]: icon !== ''});

    return (
        <div className='widget-header'>
            <h2 className={classes}>
                {heading}
            </h2>
        </div>
    );

};

WidgetHeader.propTypes = {
    icon: PropTypes.string,
    heading: PropTypes.string.isRequired,
};

WidgetHeader.defaultProps = {
    icon: '',
};

export default WidgetHeader;
